const CorLoader = () => {
  return (
    <div className="flex-1 space-y-2 p-5 animate-pulse">
      <div className="h-4 bg-gray-100 rounded w-1/5"></div>
      <div className="h-4 bg-gray-100 rounded w-3/5"></div>
      <div className="h-4 bg-gray-100 rounded w-4/5"></div>
    </div>
  );
};

export default CorLoader;
